// export anonymous function
export default (function () {
	document.addEventListener('DOMContentLoaded', function () {

		var wpcf7El = document.querySelector('.wpcf7');

		if (!wpcf7El) {
			return;
		}

		function loadExternalCSS(url) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = url;
			document.head.appendChild(link);
		}

		const formCssUrl = window.location.origin + '/wp-content/plugins/breakdance/subplugins/breakdance-elements/dependencies-files/awesome-form@1/css/form.css';
		loadExternalCSS(formCssUrl);


		// prefill job title
		let jobInput = document.querySelector('input[name="bewerbung-job"]');
		let formShortcode = document.getElementById('job-form-shortcode');

		if (!jobInput || !formShortcode) {
			return;
		}

		let jobTitle = formShortcode.getAttribute('data-job');

		// Select the node that will be observed for mutations
		const targetNode = formShortcode.querySelector('.wpcf7-form');

		// Options for the observer (which mutations to observe)
		const config = {attributes: true, childList: false, subtree: false};

		// Callback function to execute when mutations are observed
		const callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === "attributes") {
					if (targetNode.classList.contains('init')) {
						if (jobInput && formShortcode) {
							jobInput.value = jobTitle;
						}
						observer.disconnect();
					}
				}
			}
		};

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);

		wpcf7El.addEventListener('wpcf7submit', function (event) {
			if (jobInput && formShortcode) {
				jobInput.value = jobTitle;
			}
		}, false);
	});
})();
